import { createSlice } from '@reduxjs/toolkit';

const OrderSlice = createSlice({
  name: 'orderStorage',
  initialState: {
    orderItems: JSON.parse(localStorage.getItem('orderItems')) || [], 
  },
  reducers: {
    setOrder: (state, action) => {
      state.orderItems.push(action.payload);
      localStorage.setItem('orderItems', JSON.stringify(state.orderItems));
    },
    clearOrder: (state) => {
      state.orderItems = [];
      localStorage.removeItem('orderItems');
    },
    removeOrderItem: (state, action) => {      
      state.orderItems = state.orderItems.filter(item => item.timestamp !== action.payload);
      localStorage.setItem('orderItems', JSON.stringify(state.orderItems));
    },
    updateOrderItem: (state, action) => {
      const index = state.orderItems.findIndex(item => item.timestamp === action.payload.timestamp);
      if (index !== -1) {
        state.orderItems[index] = action.payload;
        localStorage.setItem('orderItems', JSON.stringify(state.orderItems));
      }
    },
  },
});

export const { setOrder, clearOrder, removeOrderItem, updateOrderItem } = OrderSlice.actions;
export default OrderSlice.reducer;